import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Hash, Save, Loader2 } from "lucide-react";

export default function DocNoSettings() {
  const [docno, setDocno] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/docno").then((r) => setDocno(r.data.items || [])).catch(() => {}); }, []);
  const update = (type, field, value) => setDocno((arr) => arr.map((d) => (d.type === type ? { ...d, [field]: value } : d)));
  const save = async () => {
    setSaving(true);
    try {
      const config = {};
      docno.forEach((d) => { config[d.type] = { prefix: (d.prefix || "").toUpperCase(), start: Number(d.start) || 1 }; });
      const { data } = await api.put("/settings/docno", { config });
      setDocno(data.items || []); toast.success("Belge No ayarları kaydedildi");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" data-testid="docno-settings">
      <h2 className="mb-1 flex items-center gap-2 font-heading text-lg font-bold text-slate-800"><Hash className="h-5 w-5 text-brand-green" /> Belge No</h2>
      <p className="mb-4 text-sm text-slate-500">Her işlem türü için belge numarası öneki ve başlangıç numarası.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="docno-table">
          <thead><tr className="border-b border-slate-100 text-left text-[11px] uppercase text-slate-400">
            <th className="py-2">İşlem Türü</th><th>Önek</th><th>Başlangıç No</th><th>Örnek</th>
          </tr></thead>
          <tbody>
            {docno.map((d) => (
              <tr key={d.type} data-testid={`docno-row-${d.type}`} className="border-b border-slate-50">
                <td className="py-2 font-medium text-slate-700">{d.label}</td>
                <td className="pr-3"><Input data-testid={`docno-prefix-${d.type}`} value={d.prefix} onChange={(e) => update(d.type, "prefix", e.target.value.toUpperCase())} className="h-8 w-24 font-mono uppercase" maxLength={8} /></td>
                <td className="pr-3"><Input data-testid={`docno-start-${d.type}`} type="number" min="1" value={d.start} onChange={(e) => update(d.type, "start", e.target.value)} className="h-8 w-24 tabular" /></td>
                <td className="font-mono text-[11px] text-slate-400">{(d.prefix || d.default_prefix)}-YYYYAAGG-{String(Math.max(1, Number(d.start) || 1)).padStart(4, "0")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Button data-testid="docno-save" onClick={save} disabled={saving} className="mt-4 bg-brand-green text-white hover:bg-brand-green-600">
        {saving ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Save className="mr-1.5 h-4 w-4" />} Kaydet
      </Button>
    </div>
  );
}
